import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  // Auth uses Bearer token (localStorage) in Authorization header — no cookies.
  // Setting withCredentials:true would force browsers to reject cross-origin
  // responses with `Access-Control-Allow-Origin: *` (which K8s ingress sets),
  // breaking custom domains like fkcinema.com / www.fkflix.com.
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cc_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      // token invalid; don't auto-redirect from here (components handle)
    }
    return Promise.reject(e);
  }
);
